import clsx from '~/utils/clsx';
import { NextButton as NextButtonCN } from './next-button.css';

export default function NextButton(p) {
  return <button class={clsx('NextButton', NextButtonCN)} disabled={p.disabled || false} onClick={p.onClick}>{p.text}</button>;
}

